export const GRETA_AI_CHAT_FINANCE_PREVIEW_BENEFITS = [
  {
    leadKey: 'Greta.FinancePreviewBenefitStatusLeadKey',
    textKey: 'Greta.FinancePreviewBenefitStatusKey',
  },
  {
    leadKey: 'Greta.FinancePreviewBenefitApprovalsLeadKey',
    textKey: 'Greta.FinancePreviewBenefitApprovalsKey',
  },
  {
    leadKey: 'Greta.FinancePreviewBenefitDueLeadKey',
    textKey: 'Greta.FinancePreviewBenefitDueKey',
  },
]

export const QA_NAME_GRETA_AI_CHAT_FINANCE_PREVIEW_SUPPORT =
  'gretaAIChatFinancePreviewSupport'
